import styled from "styled-components";
type buttonporps = {
    primary?: boolean
}
export const Button = styled.input<buttonporps>`
    padding: 1em 2em;
    border-radius: .5em;
    margin: 1em;
    cursor: pointer;
    transition-duration: .3s;
    ${
        props=>props.primary? 
        `
        background-color: #04D939;
        border: 1px solid #04D939;
        color: white;
        `
        :
        `
        background-color: transparent;
        border: 1px solid #04D939;
        color: #04D939;
        `
    }
    &:hover{
        box-shadow: rgb(4, 217, 57) 0px 5px 10px;
    }
    @media screen and (max-width: 600px) {
            margin: 1em 0px;
            flex-grow:1;
        };
`